import ProductCardList from './ProductCardList';

export default ProductCardList;
